<script setup>
    import { insertHyphens } from '@/functions/text';
    const props = defineProps({
        data: {
            type: String,
            default: null,
        },
        tag: {
            type: String,
            default: 'h2'
        },
        cssClass: {
            String,
            default: null
        }
    });    
</script>
<template>
    <component :is="tag" v-html="insertHyphens(data)" :class="cssClass"></component>
</template>